// extracted by mini-css-extract-plugin
export default {"addToCartControl":"F0-z","giftCard":"G0-z","btnContainer":"H0-z","cartButton":"I0-z","disabled":"J0-z"};